import React from "react";
import { V3Body } from "../Typography";
import { TCTACommonWrapper, V3TertiaryCTABtn } from "./V3TertiaryCTA.styles";
import { SharedTertiaryProps, V3TertiaryButtonProps, V3TertiaryCTAIconPosition, V3TertiaryCTAColor } from "./V3TertiaryCTA.types";

export const TCTACommon = ({ icon, text, iconPosition = V3TertiaryCTAIconPosition.left }: SharedTertiaryProps) => {
    return (
        <TCTACommonWrapper $iconPosition={iconPosition}>
            {icon && <div>{icon}</div>}
            {text && (
                <V3Body as="div">
                    <strong>{text}</strong>
                </V3Body>
            )}
        </TCTACommonWrapper>
    );
};

export const V3TertiaryButton = ({ iconPosition, icon, text, ctaColor = V3TertiaryCTAColor.color, ...rest }: V3TertiaryButtonProps) => (
    <V3TertiaryCTABtn $ctaColor={ctaColor} {...rest}>
        <TCTACommon iconPosition={iconPosition} icon={icon} text={text} />
    </V3TertiaryCTABtn>
);
